import { render, staticRenderFns } from "./infolistItem.vue?vue&type=template&id=bf2f16e6&scoped=true&"
import script from "./infolistItem.vue?vue&type=script&lang=js&"
export * from "./infolistItem.vue?vue&type=script&lang=js&"
import style0 from "./infolistItem.vue?vue&type=style&index=0&id=bf2f16e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2f16e6",
  null
  
)

export default component.exports